import React, { useEffect, useState } from "react";
import { collection, getDocs, addDoc } from "firebase/firestore";
import { signOut } from "firebase/auth";
import { useNavigate } from "react-router-dom";
import { db, auth } from "./firebase";
import { QRCodeSVG } from "qrcode.react";
import { toPng } from "html-to-image";

function AdminQR() {
  const navigate = useNavigate();
  const [families, setFamilies] = useState([]);
  const [newFamilyName, setNewFamilyName] = useState("");

  useEffect(() => {
    async function fetchFamilies() {
      try {
        const snapshot = await getDocs(collection(db, "parents"));
        const data = snapshot.docs.map((doc) => ({
          id: doc.id,
          ...doc.data(),
        }));
        setFamilies(data);
      } catch (error) {
        console.error("Error fetching families:", error);
      }
    }

    fetchFamilies();
  }, []);

  function generateToken(length = 10) {
    const chars =
      "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
    let result = "";

    for (let i = 0; i < length; i++) {
      result += chars.charAt(Math.floor(Math.random() * chars.length));
    }

    return result;
  }

  function generateSlug(name) {
    return (
      name
        .toLowerCase()
        .trim()
        .replace(/[^a-z0-9\s-]/g, "")
        .replace(/\s+/g, "-") + "-family"
    );
  }

    const handleLogout = async () => {
    try {
      await signOut(auth);
      navigate("/login");
    } catch (error) {
      console.error("Error logging out:", error);
      alert("There was a problem logging out. Please try again.");
    }
  };

  const handleCreateFamily = async () => {
    if (!newFamilyName.trim()) {
      alert("Please enter a family name.");
      return;
    }

    try {
      const docRef = await addDoc(collection(db, "parents"), {
        parentName: newFamilyName.trim(),
        parentEmail: "",
        parentPhone: "",
        childName: "",
        familySlug: generateSlug(newFamilyName),
        publicToken: generateToken(),
        createdAt: new Date().toISOString(),
      });

      console.log("Family created with ID:", docRef.id);
      alert("Family created successfully!");

      setNewFamilyName("");

      const snapshot = await getDocs(collection(db, "parents"));
      const data = snapshot.docs.map((doc) => ({
        id: doc.id,
        ...doc.data(),
      }));
      setFamilies(data);
    } catch (error) {
      console.error("Error creating family:", error);
      alert(`Error creating family: ${error.message}`);
    }
  };

  const handleDownload = async (id) => {
    const qrElement = document.getElementById(`qr-${id}`);
    if (!qrElement) return;

    try {
      const dataUrl = await toPng(qrElement, { pixelRatio: 3 });
      const link = document.createElement("a");
      link.download = `QR_${id}.png`;
      link.href = dataUrl;
      link.click();
    } catch (error) {
      console.error("Error downloading QR:", error);
    }
  };

  return (
    <div className="portal-page">
      <img
        src={`${process.env.PUBLIC_URL}/pink-collective-logo.png`}
        alt="The Pink Collective logo"
        className="portal-logo"
      />

<div className="portal-card admin-card">

  <div style={{ display: "flex", justifyContent: "flex-end" }}>
    <button
      className="portal-button"
      onClick={handleLogout}
      style={{ width: "auto", padding: "10px 20px" }}
    >
      Log Out
    </button>
  </div>

  <h1 className="portal-title">Admin QR Generator</h1>
        <div className="portal-underline" />
        <p className="portal-text">
          Create a family profile and download a QR code that links directly to
          that family’s public page.
        </p>

        <div className="admin-create-section">
          <label className="portal-label">
            Family Name
            <input
              type="text"
              placeholder="Enter family name"
              value={newFamilyName}
              onChange={(e) => setNewFamilyName(e.target.value)}
              className="portal-input"
            />
          </label>

          <button className="portal-button" onClick={handleCreateFamily}>
            Create Family
          </button>
        </div>
      </div>

      <div className="admin-grid">
        {families.map((fam) => (
          <div key={fam.id} className="portal-card admin-family-card">
            <h2 className="admin-family-title">
              {fam.parentName || "Unnamed Family"}
            </h2>
            <div className="portal-underline admin-small-underline" />

            <div id={`qr-${fam.id}`} className="admin-qr-box">
              <QRCodeSVG
                value={`${window.location.origin}/p/${fam.publicToken}`}
                size={220}
                includeMargin={true}
                level="H"
              />
            </div>

            <p className="admin-token-path">{`/p/${fam.publicToken}`}</p>

            <button
              className="portal-button"
              onClick={() => handleDownload(fam.id)}
            >
              Download QR
            </button>
          </div>
        ))}
      </div>
    </div>
  );
}

export default AdminQR;